import React from 'react'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { useScript } from '../../../../hooks/useScript'

declare const MktoForms2: {
  loadForm: (url: string, form: string, id: number) => any
  whenReady: (fn: () => void) => void
}

const extractFormId = (code: string): number | undefined => {
  const m = code.match(/MktoForms2\.loadForm\(.+?, (\d+)\)/)
  return m && m.length > 1 ? parseInt(m[1], 10) : undefined
}

type Props = {
  code: string
}

export const MarketoForm: React.FC<Props> = (props) => {
  const formId = extractFormId(props.code)
  useScript('//app-sn03.marketo.com/js/forms2/js/forms2.min.js', () => {
    const interval = setInterval(() => {
      if (typeof MktoForms2 !== 'undefined' && formId) {
        // TODO: a bit ugly...
        const script = document.createElement('script')
        script.src = '/static/marketo-validation.js'
        document.body.appendChild(script)
        MktoForms2.loadForm('//app-sn03.marketo.com', '550-EMV-558', formId)
        MktoForms2.whenReady(function () {
          const reset = function () {
            const marketoClassName = [
              'mktoHasWidth',
              'mktoFormCol',
              'mktoOffset',
            ]
            let target: HTMLElement[] = []
            for (let i = 0; i < marketoClassName.length; i++) {
              let _target = []
              _target[i] = [].slice.call(
                document.getElementsByClassName(marketoClassName[i])
              )
              target = target.concat(_target[i])
            }

            for (let i = 0; i < target.length; i++) {
              target[i].setAttribute('style', '')
            }
          }

          reset()

          window.addEventListener('resize', reset)
        })
        clearInterval(interval)
      }
    }, 100)
  })

  const selectBackground = '/static/images/enterprise/form/arrow1s-down.svg'
  return (
    <div
      css={css`
        .mktoForm,
        .mktoForm * {
          padding: 0;
        }
        .mktoForm .mktoFormCol {
          float: none;
          width: 100%;
        }
        .mktoForm .mktoFieldWrap {
          float: none;
          display: block;
          width: 100%;
        }
        .mktoForm .mktoFormRow {
          display: flex;
          grid-gap: 12px;
        }
        .mktoForm .mktoOffset {
          float: none;
          height: auto;
        }
        .mktoForm .mktoClear {
          display: none;
        }
        .mktoForm .mktoRequiredField .mktoAsterix {
          color: ${colors.red60};
        }
        .mktoForm .mktoLabel {
          float: none;
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
          grid-gap: 4px;
          margin-top: 24px;
          padding: 0 0 8px;
          color: ${colors.textStrong};
          font-size: 14px;
          font-weight: ${font.weight.bold};
          line-height: 1.25;
          letter-spacing: 0.02em;
        }
        .mktoForm.mktoLayoutAbove .mktoLabel {
          padding: 0 0 8px;
        }
        .mktoForm .mktoField {
          float: none;
          width: 100%;
          height: auto;
          padding: 12px 14px;
          background: ${colors.backgroundGray};
          border: 1px solid ${colors.backgroundGray};
          border-radius: 2px;
          font-size: 16px;
          line-height: 1.25;
          letter-spacing: 0.02em;
          &::placeholder {
            color: ${colors.textLight};
          }
          &:hover,
          &:focus {
            border: 1px solid ${colors.blue50};
            box-shadow: 0px 0px 0px 3px ${colors.blue50}33;
          }
        }
        .mktoForm.mktoLayoutAbove select.mktoField {
          background-image: url(${selectBackground});
          background-repeat: no-repeat;
          background-position: calc(100% - 9px) center;
          appearance: none;
        }
        .mktoForm.mktoLayoutAbove textarea.mktoField {
          float: none;
          min-height: 88px;
          padding: 8px 12px;
        }
        .mktoForm .mktoHtmlText {
          margin-top: 8px;
          color: ${colors.text};
          font-size: 12px;
          line-height: 1.5;
          letter-spacing: 0.02em;
          a {
            color: ${colors.link};
          }
        }
        .mktoForm .mktoButtonRow {
          display: block;
          margin-top: 24px;
        }
        .mktoForm .mktoButtonWrap.mktoMinimal .mktoButton {
          width: 100%;
          padding: 16px 0;
          background: ${colors.black10};
          border: 0;
          box-shadow: none;
          color: ${colors.textInvert};
          font-size: 14px;
          font-weight: ${font.weight.bold};
          line-height: 100%;
          text-shadow: none;
          &:hover {
            background: ${colors.black30};
            box-shadow: none;
            color: ${colors.textInvert};
          }
        }
        .mktoForm .mktoError {
          position: static;
        }
        .mktoForm .mktoError .mktoErrorArrowWrap {
          display: none;
        }
        .mktoForm .mktoError .mktoErrorMsg {
          max-width: none;
          margin-top: 8px;
          padding: 0;
          background: none;
          border: 0;
          box-shadow: none;
          color: ${colors.red60};
          font-size: 12px;
          line-height: 1.5;
          letter-spacing: 0.02em;
          text-shadow: none;
        }
      `}
    >
      <form id={`mktoForm_${formId}`}></form>
    </div>
  )
}
